import '../assets/referencePickerModal-DWB2ghBg.css';
import { e as Et, i as xe, h as Pt, a as St, f as kt, d as F, g as xt, c as $t, j as Ot } from "./index-CU14QsCg.mjs";
import { n as O } from "./_plugin-vue2_normalizer-Bj5bLKV4.mjs";
import { r as q, P as Nt, a as S, Q as Lt, R as Tt, S as Ke, T as It, u as Vt, U as At, E as jt, V as Bt } from "./_l10n-BaNxGGXy.mjs";
import ye from "@nextcloud/axios";
import { loadState as Je } from "@nextcloud/initial-state";
import { imagePath as qt, generateOcsUrl as Z } from "@nextcloud/router";
import ge from "../Components/NcEmptyContent.mjs";
import { N as Xe } from "./index-CnpswYi6.mjs";
import { N as Ye } from "./NcSelect-Bo71Yd6L.mjs";
import { useIntersectionObserver as Mt, useResizeObserver as Ut } from "@vueuse/core";
import Dt, { ref as fe } from "vue";
import { g as Wt } from "./autolink-DNGB8YSW.mjs";
import Ze from "../Components/NcButton.mjs";
import Ft from "../Components/NcLoadingIcon.mjs";
import { N as zt } from "./NcTextField-D_eUEl2B.mjs";
import { D as Ht } from "./DotsHorizontal-DfVgEXgz.mjs";
import Gt from "../Components/NcModal.mjs";
import { emit as Qt } from "@nextcloud/event-bus";
import { A as Kt } from "./ArrowLeft-kklNBL9z.mjs";
import { C as Jt } from "./Close-BtO5TPBO.mjs";
/*!
  * vue-router v3.6.5
  * (c) 2022 Evan You
  * @license MIT
  */
function V(t, e) {
  if (!t)
    throw new Error("[vue-router] " + e);
}
function C(t, e) {
  t || typeof console < "u" && console.warn("[vue-router] " + e);
}
function k(t, e) {
  for (var r in e)
    t[r] = e[r];
  return t;
}
var Xt = /[!'()*]/g, Yt = function(t) {
  return "%" + t.charCodeAt(0).toString(16);
}, Zt = /%2C/g, j = function(t) {
  return encodeURIComponent(t).replace(Xt, Yt).replace(Zt, ",");
};
function he(t) {
  try {
    return decodeURIComponent(t);
  } catch {
    process.env.NODE_ENV !== "production" && C(!1, 'Error decoding "' + t + '". Leaving it intact.');
  }
  return t;
}
function er(t, e, r) {
  e === void 0 && (e = {});
  var n = r || tr, i;
  try {
    i = n(t || "");
  } catch (o) {
    process.env.NODE_ENV !== "production" && C(!1, o.message), i = {};
  }
  for (var s in e) {
    var a = e[s];
    i[s] = Array.isArray(a) ? a.map($e) : $e(a);
  }
  return i;
}
var $e = function(t) {
  return t == null || typeof t == "object" ? t : String(t);
};
function tr(t) {
  var e = {};
  return t = t.trim().replace(/^(\?|#|&)/, ""), t && t.split("&").forEach(function(r) {
    var n = r.replace(/\+/g, " ").split("="), i = he(n.shift()), s = n.length > 0 ? he(n.join("=")) : null;
    e[i] === void 0 ? e[i] = s : Array.isArray(e[i]) ? e[i].push(s) : e[i] = [e[i], s];
  }), e;
}
function rr(t) {
  var e = t ? Object.keys(t).map(function(r) {
    var n = t[r];
    if (n === void 0)
      return "";
    if (n === null)
      return j(r);
    if (Array.isArray(n)) {
      var i = [];
      return n.forEach(function(s) {
        s !== void 0 && (s === null ? i.push(j(r)) : i.push(j(r) + "=" + j(s)));
      }), i.join("&");
    }
    return j(r) + "=" + j(n);
  }).filter(function(r) {
    return r.length > 0;
  }).join("&") : null;
  return e ? "?" + e : "";
}
var ee = /\/?$/;
function te(t, e, r, n) {
  var i = n && n.options.stringifyQuery, s = e.query || {};
  try {
    s = pe(s);
  } catch {
  }
  var a = {
    name: e.name || t && t.name,
    meta: t && t.meta || {},
    path: e.path || "/",
    hash: e.hash || "",
    query: s,
    params: e.params || {},
    fullPath: Oe(e, i),
    matched: t ? nr(t) : []
  };
  return r && (a.redirectedFrom = Oe(r, i)), Object.freeze(a);
}
function pe(t) {
  if (Array.isArray(t))
    return t.map(pe);
  if (t && typeof t == "object") {
    var e = {};
    for (var r in t)
      e[r] = pe(t[r]);
    return e;
  } else
    return t;
}
var I = te(null, {
  path: "/"
});
function nr(t) {
  for (var e = []; t; )
    e.unshift(t), t = t.parent;
  return e;
}
function Oe(t, e) {
  var r = t.path, n = t.query;
  n === void 0 && (n = {});
  var i = t.hash;
  i === void 0 && (i = "");
  var s = e || rr;
  return (r || "/") + s(n) + i;
}
function et(t, e, r) {
  return e === I ? t === e : e ? t.path && e.path ? t.path.replace(ee, "") === e.path.replace(ee, "") && (r || t.hash === e.hash && Q(t.query, e.query)) : t.name && e.name ? t.name === e.name && (r || t.hash === e.hash && Q(t.query, e.query) && Q(t.params, e.params)) : !1 : !1;
}
function Q(t, e) {
  if (t === void 0 && (t = {}), e === void 0 && (e = {}), !t || !e)
    return t === e;
  var r = Object.keys(t).sort(), n = Object.keys(e).sort();
  return r.length !== n.length ? !1 : r.every(function(i, s) {
    var a = t[i], o = n[s];
    if (o !== i)
      return !1;
    var c = e[i];
    return a == null || c == null ? a === c : typeof a == "object" && typeof c == "object" ? Q(a, c) : String(a) === String(c);
  });
}
function ir(t, e) {
  return t.path.replace(ee, "/").indexOf(
    e.path.replace(ee, "/")
  ) === 0 && (!e.hash || t.hash === e.hash) && sr(t.query, e.query);
}
function sr(t, e) {
  for (var r in e)
    if (!(r in t))
      return !1;
  return !0;
}
function tt(t) {
  for (var e = 0; e < t.matched.length; e++) {
    var r = t.matched[e];
    for (var n in r.instances) {
      var i = r.instances[n], s = r.enteredCbs[n];
      if (!(!i || !s)) {
        delete r.enteredCbs[n];
        for (var a = 0; a < s.length; a++)
          i._isBeingDestroyed || s[a](i);
      }
    }
  }
}
var ar = {
  name: "RouterView",
  functional: !0,
  props: {
    name: {
      type: String,
      default: "default"
    }
  },
  render: function(e, r) {
    var n = r.props, i = r.children, s = r.parent, a = r.data;
    a.routerView = !0;
    for (var o = s.$createElement, c = n.name, u = s.$route, p = s._routerViewCache || (s._routerViewCache = {}), m = 0, h = !1; s && s._routerRoot !== s; ) {
      var v = s.$vnode ? s.$vnode.data : {};
      v.routerView && m++, v.keepAlive && s._directInactive && s._inactive && (h = !0), s = s.$parent;
    }
    if (a.routerViewDepth = m, h) {
      var d = p[c], l = d && d.component;
      return l ? (d.configProps && Ne(l, a, d.route, d.configProps), o(l, a, i)) : o();
    }
    var f = u.matched[m], y = f && f.components[c];
    if (!f || !y)
      return p[c] = null, o();
    p[c] = { component: y }, a.registerRouteInstance = function(g, b) {
      var R = f.instances[c];
      (b && R !== g || !b && R === g) && (f.instances[c] = b);
    }, (a.hook || (a.hook = {})).prepatch = function(g, b) {
      f.instances[c] = b.componentInstance;
    }, a.hook.init = function(g) {
      g.data.keepAlive && g.componentInstance && g.componentInstance !== f.instances[c] && (f.instances[c] = g.componentInstance), tt(u);
    };
    var _ = f.props && f.props[c];
    return _ && (k(p[c], {
      route: u,
      configProps: _
    }), Ne(y, a, u, _)), o(y, a, i);
  }
};
function Ne(t, e, r, n) {
  var i = e.props = or(r, n);
  if (i) {
    i = e.props = k({}, i);
    var s = e.attrs = e.attrs || {};
    for (var a in i)
      (!t.props || !(a in t.props)) && (s[a] = i[a], delete i[a]);
  }
}
function or(t, e) {
  switch (typeof e) {
    case "undefined":
      return;
    case "object":
      return e;
    case "function":
      return e(t);
    case "boolean":
      return e ? t.params : void 0;
    default:
      process.env.NODE_ENV !== "production" && C(
        !1,
        'props in "' + t.path + '" is a ' + typeof e + ", expecting an object, function or boolean."
      );
  }
}
function rt(t, e, r) {
  var n = t.charAt(0);
  if (n === "/")
    return t;
  if (n === "?" || n === "#")
    return e + t;
  var i = e.split("/");
  (!r || !i[i.length - 1]) && i.pop();
  for (var s = t.replace(/^\//, "").split("/"), a = 0; a < s.length; a++) {
    var o = s[a];
    o === ".." ? i.pop() : o !== "." && i.push(o);
  }
  return i[0] !== "" && i.unshift(""), i.join("/");
}
function cr(t) {
  var e = "", r = "", n = t.indexOf("#");
  n >= 0 && (e = t.slice(n), t = t.slice(0, n));
  var i = t.indexOf("?");
  return i >= 0 && (r = t.slice(i + 1), t = t.slice(0, i)), {
    path: t,
    query: r,
    hash: e
  };
}
function N(t) {
  return t.replace(/\/(?:\s*\/)+/g, "/");
}
var re = Array.isArray || function(t) {
  return Object.prototype.toString.call(t) == "[object Array]";
}, M = st, ur = _e, lr = dr, fr = nt, hr = it, pr = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  "(\\\\.)",
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  "([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))"
].join("|"), "g");
function _e(t, e) {
  for (var r = [], n = 0, i = 0, s = "", a = e && e.delimiter || "/", o; (o = pr.exec(t)) != null; ) {
    var c = o[0], u = o[1], p = o.index;
    if (s += t.slice(i, p), i = p + c.length, u) {
      s += u[1];
      continue;
    }
    var m = t[i], h = o[2], v = o[3], d = o[4], l = o[5], f = o[6], y = o[7];
    s && (r.push(s), s = "");
    var _ = h != null && m != null && m !== h, g = f === "+" || f === "*", b = f === "?" || f === "*", R = o[2] || a, E = d || l;
    r.push({
      name: v || n++,
      prefix: h || "",
      delimiter: R,
      optional: b,
      repeat: g,
      partial: _,
      asterisk: !!y,
      pattern: E ? yr(E) : y ? ".*" : "[^" + K(R) + "]+?"
    });
  }
  return i < t.length && (s += t.substr(i)), s && r.push(s), r;
}
function dr(t, e) {
  return nt(_e(t, e), e);
}
function vr(t) {
  return encodeURI(t).replace(/[\/?#]/g, function(e) {
    return "%" + e.charCodeAt(0).toString(16).toUpperCase();
  });
}
function mr(t) {
  return encodeURI(t).replace(/[?#]/g, function(e) {
    return "%" + e.charCodeAt(0).toString(16).toUpperCase();
  });
}
function nt(t, e) {
  for (var r = new Array(t.length), n = 0; n < t.length; n++)
    typeof t[n] == "object" && (r[n] = new RegExp("^(?:" + t[n].pattern + ")$", be(e)));
  return function(i, s) {
    for (var a = "", o = i || {}, c = s || {}, u = c.pretty ? vr : encodeURIComponent, p = 0; p < t.length; p++) {
      var m = t[p];
      if (typeof m == "string") {
        a += m;
        continue;
      }
      var h = o[m.name], v;
      if (h == null)
        if (m.optional) {
          m.partial && (a += m.prefix);
          continue;
        } else
          throw new TypeError('Expected "' + m.name + '" to be defined');
      if (re(h)) {
        if (!m.repeat)
          throw new TypeError('Expected "' + m.name + '" to not repeat, but received `' + JSON.stringify(h) + "`");
        if (h.length === 0) {
          if (m.optional)
            continue;
          throw new TypeError('Expected "' + m.name + '" to not be empty');
        }
        for (var d = 0; d < h.length; d++) {
          if (v = u(h[d]), !r[p].test(v))
            throw new TypeError('Expected all "' + m.name + '" to match "' + m.pattern + '", but received `' + JSON.stringify(v) + "`");
          a += (d === 0 ? m.prefix : m.delimiter) + v;
        }
        continue;
      }
      if (v = m.asterisk ? mr(h) : u(h), !r[p].test(v))
        throw new TypeError('Expected "' + m.name + '" to match "' + m.pattern + '", but received "' + v + '"');
      a += m.prefix + v;
    }
    return a;
  };
}
function K(t) {
  return t.replace(/([.+*?=^!:${}()[\]|\/\\])/g, "\\$1");
}
function yr(t) {
  return t.replace(/([=!:$\/()])/g, "\\$1");
}
function we(t, e) {
  return t.keys = e, t;
}
function be(t) {
  return t && t.sensitive ? "" : "i";
}
function gr(t, e) {
  var r = t.source.match(/\((?!\?)/g);
  if (r)
    for (var n = 0; n < r.length; n++)
      e.push({
        name: n,
        prefix: null,
        delimiter: null,
        optional: !1,
        repeat: !1,
        partial: !1,
        asterisk: !1,
        pattern: null
      });
  return we(t, e);
}
function _r(t, e, r) {
  for (var n = [], i = 0; i < t.length; i++)
    n.push(st(t[i], e, r).source);
  var s = new RegExp("(?:" + n.join("|") + ")", be(r));
  return we(s, e);
}
function wr(t, e, r) {
  return it(_e(t, r), e, r);
}
function it(t, e, r) {
  re(e) || (r = /** @type {!Object} */
  e || r, e = []), r = r || {};
  for (var n = r.strict, i = r.end !== !1, s = "", a = 0; a < t.length; a++) {
    var o = t[a];
    if (typeof o == "string")
      s += K(o);
    else {
      var c = K(o.prefix), u = "(?:" + o.pattern + ")";
      e.push(o), o.repeat && (u += "(?:" + c + u + ")*"), o.optional ? o.partial ? u = c + "(" + u + ")?" : u = "(?:" + c + "(" + u + "))?" : u = c + "(" + u + ")", s += u;
    }
  }
  var p = K(r.delimiter || "/"), m = s.slice(-p.length) === p;
  return n || (s = (m ? s.slice(0, -p.length) : s) + "(?:" + p + "(?=$))?"), i ? s += "$" : s += n && m ? "" : "(?=" + p + "|$)", we(new RegExp("^" + s, be(r)), e);
}
function st(t, e, r) {
  return re(e) || (r = /** @type {!Object} */
  e || r, e = []), r = r || {}, t instanceof RegExp ? gr(
    t,
    /** @type {!Array} */
    e
  ) : re(t) ? _r(
    /** @type {!Array} */
    t,
    /** @type {!Array} */
    e,
    r
  ) : wr(
    /** @type {string} */
    t,
    /** @type {!Array} */
    e,
    r
  );
}
M.parse = ur;
M.compile = lr;
M.tokensToFunction = fr;
M.tokensToRegExp = hr;
var Le = /* @__PURE__ */ Object.create(null);
function J(t, e, r) {
  e = e || {};
  try {
    var n = Le[t] || (Le[t] = M.compile(t));
    return typeof e.pathMatch == "string" && (e[0] = e.pathMatch), n(e, { pretty: !0 });
  } catch (i) {
    return process.env.NODE_ENV !== "production" && C(typeof e.pathMatch == "string", "missing param for " + r + ": " + i.message), "";
  } finally {
    delete e[0];
  }
}
function Re(t, e, r, n) {
  var i = typeof t == "string" ? { path: t } : t;
  if (i._normalized)
    return i;
  if (i.name) {
    i = k({}, t);
    var s = i.params;
    return s && typeof s == "object" && (i.params = k({}, s)), i;
  }
  if (!i.path && i.params && e) {
    i = k({}, i), i._normalized = !0;
    var a = k(k({}, e.params), i.params);
    if (e.name)
      i.name = e.name, i.params = a;
    else if (e.matched.length) {
      var o = e.matched[e.matched.length - 1].path;
      i.path = J(o, a, "path " + e.path);
    } else
      process.env.NODE_ENV !== "production" && C(!1, "relative params navigation requires a current route.");
    return i;
  }
  var c = cr(i.path || ""), u = e && e.path || "/", p = c.path ? rt(c.path, u, r || i.append) : u, m = er(
    c.query,
    i.query,
    n && n.options.parseQuery
  ), h = i.hash || c.hash;
  return h && h.charAt(0) !== "#" && (h = "#" + h), {
    _normalized: !0,
    path: p,
    query: m,
    hash: h
  };
}
var br = [String, Object], Rr = [String, Array], Te = function() {
}, Ie, Ve, Ae, at = {
  name: "RouterLink",
  props: {
    to: {
      type: br,
      required: !0
    },
    tag: {
      type: String,
      default: "a"
    },
    custom: Boolean,
    exact: Boolean,
    exactPath: Boolean,
    append: Boolean,
    replace: Boolean,
    activeClass: String,
    exactActiveClass: String,
    ariaCurrentValue: {
      type: String,
      default: "page"
    },
    event: {
      type: Rr,
      default: "click"
    }
  },
  render: function(e) {
    var r = this, n = this.$router, i = this.$route, s = n.resolve(
      this.to,
      i,
      this.append
    ), a = s.location, o = s.route, c = s.href, u = {}, p = n.options.linkActiveClass, m = n.options.linkExactActiveClass, h = p == null ? "router-link-active" : p, v = m == null ? "router-link-exact-active" : m, d = this.activeClass == null ? h : this.activeClass, l = this.exactActiveClass == null ? v : this.exactActiveClass, f = o.redirectedFrom ? te(null, Re(o.redirectedFrom), null, n) : o;
    u[l] = et(i, f, this.exactPath), u[d] = this.exact || this.exactPath ? u[l] : ir(i, f);
    var y = u[l] ? this.ariaCurrentValue : null, _ = function(le) {
      je(le) && (r.replace ? n.replace(a, Te) : n.push(a, Te));
    }, g = { click: je };
    Array.isArray(this.event) ? this.event.forEach(function(le) {
      g[le] = _;
    }) : g[this.event] = _;
    var b = { class: u }, R = !this.$scopedSlots.$hasNormal && this.$scopedSlots.default && this.$scopedSlots.default({
      href: c,
      route: o,
      navigate: _,
      isActive: u[d],
      isExactActive: u[l]
    });
    if (R) {
      if (process.env.NODE_ENV !== "production" && !this.custom && (!Ie && C(!1, 'In Vue Router 4, the v-slot API will by default wrap its content with an <a> element. Use the custom prop to remove this warning:\n<router-link v-slot="{ navigate, href }" custom></router-link>\n'), Ie = !0), R.length === 1)
        return R[0];
      if (R.length > 1 || !R.length)
        return process.env.NODE_ENV !== "production" && C(
          !1,
          '<router-link> with to="' + this.to + "\" is trying to use a scoped slot but it didn't provide exactly one child. Wrapping the content with a span element."
        ), R.length === 0 ? e() : e("span", {}, R);
    }
    if (process.env.NODE_ENV !== "production" && ("tag" in this.$options.propsData && !Ve && (C(
      !1,
      "<router-link>'s tag prop is deprecated and has been removed in Vue Router 4. Use the v-slot API to remove this warning: https://next.router.vuejs.org/guide/migration/#removal-of-event-and-tag-props-in-router-link."
    ), Ve = !0), "event" in this.$options.propsData && !Ae && (C(
      !1,
      "<router-link>'s event prop is deprecated and has been removed in Vue Router 4. Use the v-slot API to remove this warning: https://next.router.vuejs.org/guide/migration/#removal-of-event-and-tag-props-in-router-link."
    ), Ae = !0)), this.tag === "a")
      b.on = g, b.attrs = { href: c, "aria-current": y };
    else {
      var E = ot(this.$slots.default);
      if (E) {
        E.isStatic = !1;
        var P = E.data = k({}, E.data);
        P.on = P.on || {};
        for (var $ in P.on) {
          var U = P.on[$];
          $ in g && (P.on[$] = Array.isArray(U) ? U : [U]);
        }
        for (var H in g)
          H in P.on ? P.on[H].push(g[H]) : P.on[H] = _;
        var ke = E.data.attrs = k({}, E.data.attrs);
        ke.href = c, ke["aria-current"] = y;
      } else
        b.on = g;
    }
    return e(this.tag, b, this.$slots.default);
  }
};
function je(t) {
  if (!(t.metaKey || t.altKey || t.ctrlKey || t.shiftKey) && !t.defaultPrevented && !(t.button !== void 0 && t.button !== 0)) {
    if (t.currentTarget && t.currentTarget.getAttribute) {
      var e = t.currentTarget.getAttribute("target");
      if (/\b_blank\b/i.test(e))
        return;
    }
    return t.preventDefault && t.preventDefault(), !0;
  }
}
function ot(t) {
  if (t) {
    for (var e, r = 0; r < t.length; r++)
      if (e = t[r], e.tag === "a" || e.children && (e = ot(e.children)))
        return e;
  }
}
var ne;
function ie(t) {
  if (!(ie.installed && ne === t)) {
    ie.installed = !0, ne = t;
    var e = function(i) {
      return i !== void 0;
    }, r = function(i, s) {
      var a = i.$options._parentVnode;
      e(a) && e(a = a.data) && e(a = a.registerRouteInstance) && a(i, s);
    };
    t.mixin({
      beforeCreate: function() {
        e(this.$options.router) ? (this._routerRoot = this, this._router = this.$options.router, this._router.init(this), t.util.defineReactive(this, "_route", this._router.history.current)) : this._routerRoot = this.$parent && this.$parent._routerRoot || this, r(this, this);
      },
      destroyed: function() {
        r(this);
      }
    }), Object.defineProperty(t.prototype, "$router", {
      get: function() {
        return this._routerRoot._router;
      }
    }), Object.defineProperty(t.prototype, "$route", {
      get: function() {
        return this._routerRoot._route;
      }
    }), t.component("RouterView", ar), t.component("RouterLink", at);
    var n = t.config.optionMergeStrategies;
    n.beforeRouteEnter = n.beforeRouteLeave = n.beforeRouteUpdate = n.created;
  }
}
var z = typeof window < "u";
function G(t, e, r, n, i) {
  var s = e || [], a = r || /* @__PURE__ */ Object.create(null), o = n || /* @__PURE__ */ Object.create(null);
  t.forEach(function(h) {
    de(s, a, o, h, i);
  });
  for (var c = 0, u = s.length; c < u; c++)
    s[c] === "*" && (s.push(s.splice(c, 1)[0]), u--, c--);
  if (process.env.NODE_ENV === "development") {
    var p = s.filter(function(h) {
      return h && h.charAt(0) !== "*" && h.charAt(0) !== "/";
    });
    if (p.length > 0) {
      var m = p.map(function(h) {
        return "- " + h;
      }).join("\n");
      C(!1, "Non-nested routes must include a leading slash character. Fix the following routes: \n" + m);
    }
  }
  return {
    pathList: s,
    pathMap: a,
    nameMap: o
  };
}
function de(t, e, r, n, i, s) {
  var a = n.path, o = n.name;
  process.env.NODE_ENV !== "production" && (V(a != null, '"path" is required in a route configuration.'), V(
    typeof n.component != "string",
    'route config "component" for path: ' + String(
      a || o
    ) + " cannot be a string id. Use an actual component instead."
  ), C(
    // eslint-disable-next-line no-control-regex
    !/[^\u0000-\u007F]+/.test(a),
    'Route with path "' + a + '" contains unencoded characters, make sure your path is correctly encoded before passing it to the router. Use encodeURI to encode static segments of your path.'
  ));
  var c = n.pathToRegexpOptions || {}, u = Er(a, i, c.strict);
  typeof n.caseSensitive == "boolean" && (c.sensitive = n.caseSensitive);
  var p = {
    path: u,
    regex: Cr(u, c),
    components: n.components || { default: n.component },
    alias: n.alias ? typeof n.alias == "string" ? [n.alias] : n.alias : [],
    instances: {},
    enteredCbs: {},
    name: o,
    parent: i,
    matchAs: s,
    redirect: n.redirect,
    beforeEnter: n.beforeEnter,
    meta: n.meta || {},
    props: n.props == null ? {} : n.components ? n.props : { default: n.props }
  };
  if (n.children && (process.env.NODE_ENV !== "production" && n.name && !n.redirect && n.children.some(function(l) {
    return /^\/?$/.test(l.path);
  }) && C(
    !1,
    "Named Route '" + n.name + "' has a default child route. When navigating to this named route (:to=\"{name: '" + n.name + "'}\"), the default child route will not be rendered. Remove the name from this route and use the name of the default child route for named links instead."
  ), n.children.forEach(function(l) {
    var f = s ? N(s + "/" + l.path) : void 0;
    de(t, e, r, l, p, f);
  })), e[p.path] || (t.push(p.path), e[p.path] = p), n.alias !== void 0)
    for (var m = Array.isArray(n.alias) ? n.alias : [n.alias], h = 0; h < m.length; ++h) {
      var v = m[h];
      if (process.env.NODE_ENV !== "production" && v === a) {
        C(
          !1,
          'Found an alias with the same value as the path: "' + a + '". You have to remove that alias. It will be ignored in development.'
        );
        continue;
      }
      var d = {
        path: v,
        children: n.children
      };
      de(
        t,
        e,
        r,
        d,
        i,
        p.path || "/"
        // matchAs
      );
    }
  o && (r[o] ? process.env.NODE_ENV !== "production" && !s && C(
    !1,
    'Duplicate named routes definition: { name: "' + o + '", path: "' + p.path + '" }'
  ) : r[o] = p);
}
function Cr(t, e) {
  var r = M(t, [], e);
  if (process.env.NODE_ENV !== "production") {
    var n = /* @__PURE__ */ Object.create(null);
    r.keys.forEach(function(i) {
      C(
        !n[i.name],
        'Duplicate param keys in route with path: "' + t + '"'
      ), n[i.name] = !0;
    });
  }
  return r;
}
function Er(t, e, r) {
  return r || (t = t.replace(/\/$/, "")), t[0] === "/" || e == null ? t : N(e.path + "/" + t);
}
function Pr(t, e) {
  var r = G(t), n = r.pathList, i = r.pathMap, s = r.nameMap;
  function a(v) {
    G(v, n, i, s);
  }
  function o(v, d) {
    var l = typeof v != "object" ? s[v] : void 0;
    G([d || v], n, i, s, l), l && l.alias.length && G(
      // $flow-disable-line route is defined if parent is
      l.alias.map(function(f) {
        return { path: f, children: [d] };
      }),
      n,
      i,
      s,
      l
    );
  }
  function c() {
    return n.map(function(v) {
      return i[v];
    });
  }
  function u(v, d, l) {
    var f = Re(v, d, !1, e), y = f.name;
    if (y) {
      var _ = s[y];
      if (process.env.NODE_ENV !== "production" && C(_, "Route with name '" + y + "' does not exist"), !_)
        return h(null, f);
      var g = _.regex.keys.filter(function($) {
        return !$.optional;
      }).map(function($) {
        return $.name;
      });
      if (typeof f.params != "object" && (f.params = {}), d && typeof d.params == "object")
        for (var b in d.params)
          !(b in f.params) && g.indexOf(b) > -1 && (f.params[b] = d.params[b]);
      return f.path = J(_.path, f.params, 'named route "' + y + '"'), h(_, f, l);
    } else if (f.path) {
      f.params = {};
      for (var R = 0; R < n.length; R++) {
        var E = n[R], P = i[E];
        if (Sr(P.regex, f.path, f.params))
          return h(P, f, l);
      }
    }
    return h(null, f);
  }
  function p(v, d) {
    var l = v.redirect, f = typeof l == "function" ? l(te(v, d, null, e)) : l;
    if (typeof f == "string" && (f = { path: f }), !f || typeof f != "object")
      return process.env.NODE_ENV !== "production" && C(
        !1,
        "invalid redirect option: " + JSON.stringify(f)
      ), h(null, d);
    var y = f, _ = y.name, g = y.path, b = d.query, R = d.hash, E = d.params;
    if (b = y.hasOwnProperty("query") ? y.query : b, R = y.hasOwnProperty("hash") ? y.hash : R, E = y.hasOwnProperty("params") ? y.params : E, _) {
      var P = s[_];
      return process.env.NODE_ENV !== "production" && V(P, 'redirect failed: named route "' + _ + '" not found.'), u({
        _normalized: !0,
        name: _,
        query: b,
        hash: R,
        params: E
      }, void 0, d);
    } else if (g) {
      var $ = kr(g, v), U = J($, E, 'redirect route with path "' + $ + '"');
      return u({
        _normalized: !0,
        path: U,
        query: b,
        hash: R
      }, void 0, d);
    } else
      return process.env.NODE_ENV !== "production" && C(!1, "invalid redirect option: " + JSON.stringify(f)), h(null, d);
  }
  function m(v, d, l) {
    var f = J(l, d.params, 'aliased route with path "' + l + '"'), y = u({
      _normalized: !0,
      path: f
    });
    if (y) {
      var _ = y.matched, g = _[_.length - 1];
      return d.params = y.params, h(g, d);
    }
    return h(null, d);
  }
  function h(v, d, l) {
    return v && v.redirect ? p(v, l || d) : v && v.matchAs ? m(v, d, v.matchAs) : te(v, d, l, e);
  }
  return {
    match: u,
    addRoute: o,
    getRoutes: c,
    addRoutes: a
  };
}
function Sr(t, e, r) {
  var n = e.match(t);
  if (n) {
    if (!r)
      return !0;
  } else
    return !1;
  for (var i = 1, s = n.length; i < s; ++i) {
    var a = t.keys[i - 1];
    a && (r[a.name || "pathMatch"] = typeof n[i] == "string" ? he(n[i]) : n[i]);
  }
  return !0;
}
function kr(t, e) {
  return rt(t, e.parent ? e.parent.path : "/", !0);
}
var xr = z && window.performance && window.performance.now ? window.performance : Date;
function ct() {
  return xr.now().toFixed(3);
}
var ut = ct();
function oe() {
  return ut;
}
function lt(t) {
  return ut = t;
}
var ft = /* @__PURE__ */ Object.create(null);
function ht() {
  "scrollRestoration" in window.history && (window.history.scrollRestoration = "manual");
  var t = window.location.protocol + "//" + window.location.host, e = window.location.href.replace(t, ""), r = k({}, window.history.state);
  return r.key = oe(), window.history.replaceState(r, "", e), window.addEventListener("popstate", Be), function() {
    window.removeEventListener("popstate", Be);
  };
}
function L(t, e, r, n) {
  if (t.app) {
    var i = t.options.scrollBehavior;
    i && (process.env.NODE_ENV !== "production" && V(typeof i == "function", "scrollBehavior must be a function"), t.app.$nextTick(function() {
      var s = $r(), a = i.call(
        t,
        e,
        r,
        n ? s : null
      );
      a && (typeof a.then == "function" ? a.then(function(o) {
        Ue(o, s);
      }).catch(function(o) {
        process.env.NODE_ENV !== "production" && V(!1, o.toString());
      }) : Ue(a, s));
    }));
  }
}
function pt() {
  var t = oe();
  t && (ft[t] = {
    x: window.pageXOffset,
    y: window.pageYOffset
  });
}
function Be(t) {
  pt(), t.state && t.state.key && lt(t.state.key);
}
function $r() {
  var t = oe();
  if (t)
    return ft[t];
}
function Or(t, e) {
  var r = document.documentElement, n = r.getBoundingClientRect(), i = t.getBoundingClientRect();
  return {
    x: i.left - n.left - e.x,
    y: i.top - n.top - e.y
  };
}
function qe(t) {
  return B(t.x) || B(t.y);
}
function Me(t) {
  return {
    x: B(t.x) ? t.x : window.pageXOffset,
    y: B(t.y) ? t.y : window.pageYOffset
  };
}
function Nr(t) {
  return {
    x: B(t.x) ? t.x : 0,
    y: B(t.y) ? t.y : 0
  };
}
function B(t) {
  return typeof t == "number";
}
var Lr = /^#\d/;
function Ue(t, e) {
  var r = typeof t == "object";
  if (r && typeof t.selector == "string") {
    var n = Lr.test(t.selector) ? document.getElementById(t.selector.slice(1)) : document.querySelector(t.selector);
    if (n) {
      var i = t.offset && typeof t.offset == "object" ? t.offset : {};
      i = Nr(i), e = Or(n, i);
    } else
      qe(t) && (e = Me(t));
  } else
    r && qe(t) && (e = Me(t));
  e && ("scrollBehavior" in document.documentElement.style ? window.scrollTo({
    left: e.x,
    top: e.y,
    // $flow-disable-line
    behavior: t.behavior
  }) : window.scrollTo(e.x, e.y));
}
var T = z && function() {
  var t = window.navigator.userAgent;
  return (t.indexOf("Android 2.") !== -1 || t.indexOf("Android 4.0") !== -1) && t.indexOf("Mobile Safari") !== -1 && t.indexOf("Chrome") === -1 && t.indexOf("Windows Phone") === -1 ? !1 : window.history && typeof window.history.pushState == "function";
}();
function se(t, e) {
  pt();
  var r = window.history;
  try {
    if (e) {
      var n = k({}, r.state);
      n.key = oe(), r.replaceState(n, "", t);
    } else
      r.pushState({ key: lt(ct()) }, "", t);
  } catch {
    window.location[e ? "replace" : "assign"](t);
  }
}
function ve(t) {
  se(t, !0);
}
var A = {
  redirected: 2,
  aborted: 4,
  cancelled: 8,
  duplicated: 16
};
function Tr(t, e) {
  return ce(
    t,
    e,
    A.redirected,
    'Redirected when going from "' + t.fullPath + '" to "' + jr(
      e
    ) + '" via a navigation guard.'
  );
}
function Ir(t, e) {
  var r = ce(
    t,
    e,
    A.duplicated,
    'Avoided redundant navigation to current location: "' + t.fullPath + '".'
  );
  return r.name = "NavigationDuplicated", r;
}
function De(t, e) {
  return ce(
    t,
    e,
    A.cancelled,
    'Navigation cancelled from "' + t.fullPath + '" to "' + e.fullPath + '" with a new navigation.'
  );
}
function Vr(t, e) {
  return ce(
    t,
    e,
    A.aborted,
    'Navigation aborted from "' + t.fullPath + '" to "' + e.fullPath + '" via a navigation guard.'
  );
}
function ce(t, e, r, n) {
  var i = new Error(n);
  return i._isRouter = !0, i.from = t, i.to = e, i.type = r, i;
}
var Ar = ["params", "query", "hash"];
function jr(t) {
  if (typeof t == "string")
    return t;
  if ("path" in t)
    return t.path;
  var e = {};
  return Ar.forEach(function(r) {
    r in t && (e[r] = t[r]);
  }), JSON.stringify(e, null, 2);
}
function ae(t) {
  return Object.prototype.toString.call(t).indexOf("Error") > -1;
}
function ue(t, e) {
  return ae(t) && t._isRouter && (e == null || t.type === e);
}
function We(t, e, r) {
  var n = function(i) {
    i >= t.length ? r() : t[i] ? e(t[i], function() {
      n(i + 1);
    }) : n(i + 1);
  };
  n(0);
}
function Br(t) {
  return function(e, r, n) {
    var i = !1, s = 0, a = null;
    dt(t, function(o, c, u, p) {
      if (typeof o == "function" && o.cid === void 0) {
        i = !0, s++;
        var m = Fe(function(l) {
          Mr(l) && (l = l.default), o.resolved = typeof l == "function" ? l : ne.extend(l), u.components[p] = l, s--, s <= 0 && n();
        }), h = Fe(function(l) {
          var f = "Failed to resolve async component " + p + ": " + l;
          process.env.NODE_ENV !== "production" && C(!1, f), a || (a = ae(l) ? l : new Error(f), n(a));
        }), v;
        try {
          v = o(m, h);
        } catch (l) {
          h(l);
        }
        if (v)
          if (typeof v.then == "function")
            v.then(m, h);
          else {
            var d = v.component;
            d && typeof d.then == "function" && d.then(m, h);
          }
      }
    }), i || n();
  };
}
function dt(t, e) {
  return vt(t.map(function(r) {
    return Object.keys(r.components).map(function(n) {
      return e(
        r.components[n],
        r.instances[n],
        r,
        n
      );
    });
  }));
}
function vt(t) {
  return Array.prototype.concat.apply([], t);
}
var qr = typeof Symbol == "function" && typeof Symbol.toStringTag == "symbol";
function Mr(t) {
  return t.__esModule || qr && t[Symbol.toStringTag] === "Module";
}
function Fe(t) {
  var e = !1;
  return function() {
    for (var r = [], n = arguments.length; n--; )
      r[n] = arguments[n];
    if (!e)
      return e = !0, t.apply(this, r);
  };
}
var x = function(e, r) {
  this.router = e, this.base = Ur(r), this.current = I, this.pending = null, this.ready = !1, this.readyCbs = [], this.readyErrorCbs = [], this.errorCbs = [], this.listeners = [];
};
x.prototype.listen = function(e) {
  this.cb = e;
};
x.prototype.onReady = function(e, r) {
  this.ready ? e() : (this.readyCbs.push(e), r && this.readyErrorCbs.push(r));
};
x.prototype.onError = function(e) {
  this.errorCbs.push(e);
};
x.prototype.transitionTo = function(e, r, n) {
  var i = this, s;
  try {
    s = this.router.match(e, this.current);
  } catch (o) {
    throw this.errorCbs.forEach(function(c) {
      c(o);
    }), o;
  }
  var a = this.current;
  this.confirmTransition(
    s,
    function() {
      i.updateRoute(s), r && r(s), i.ensureURL(), i.router.afterHooks.forEach(function(o) {
        o && o(s, a);
      }), i.ready || (i.ready = !0, i.readyCbs.forEach(function(o) {
        o(s);
      }));
    },
    function(o) {
      n && n(o), o && !i.ready && (!ue(o, A.redirected) || a !== I) && (i.ready = !0, i.readyErrorCbs.forEach(function(c) {
        c(o);
      }));
    }
  );
};
x.prototype.confirmTransition = function(e, r, n) {
  var i = this, s = this.current;
  this.pending = e;
  var a = function(l) {
    !ue(l) && ae(l) && (i.errorCbs.length ? i.errorCbs.forEach(function(f) {
      f(l);
    }) : (process.env.NODE_ENV !== "production" && C(!1, "uncaught error during route navigation:"), console.error(l))), n && n(l);
  }, o = e.matched.length - 1, c = s.matched.length - 1;
  if (et(e, s) && // in the case the route map has been dynamically appended to
  o === c && e.matched[o] === s.matched[c])
    return this.ensureURL(), e.hash && L(this.router, s, e, !1), a(Ir(s, e));
  var u = Dr(
    this.current.matched,
    e.matched
  ), p = u.updated, m = u.deactivated, h = u.activated, v = [].concat(
    // in-component leave guards
    Fr(m),
    // global before hooks
    this.router.beforeHooks,
    // in-component update hooks
    zr(p),
    // in-config enter guards
    h.map(function(l) {
      return l.beforeEnter;
    }),
    // async components
    Br(h)
  ), d = function(l, f) {
    if (i.pending !== e)
      return a(De(s, e));
    try {
      l(e, s, function(y) {
        y === !1 ? (i.ensureURL(!0), a(Vr(s, e))) : ae(y) ? (i.ensureURL(!0), a(y)) : typeof y == "string" || typeof y == "object" && (typeof y.path == "string" || typeof y.name == "string") ? (a(Tr(s, e)), typeof y == "object" && y.replace ? i.replace(y) : i.push(y)) : f(y);
      });
    } catch (y) {
      a(y);
    }
  };
  We(v, d, function() {
    var l = Hr(h), f = l.concat(i.router.resolveHooks);
    We(f, d, function() {
      if (i.pending !== e)
        return a(De(s, e));
      i.pending = null, r(e), i.router.app && i.router.app.$nextTick(function() {
        tt(e);
      });
    });
  });
};
x.prototype.updateRoute = function(e) {
  this.current = e, this.cb && this.cb(e);
};
x.prototype.setupListeners = function() {
};
x.prototype.teardown = function() {
  this.listeners.forEach(function(e) {
    e();
  }), this.listeners = [], this.current = I, this.pending = null;
};
function Ur(t) {
  if (!t)
    if (z) {
      var e = document.querySelector("base");
      t = e && e.getAttribute("href") || "/", t = t.replace(/^https?:\/\/[^\/]+/, "");
    } else
      t = "/";
  return t.charAt(0) !== "/" && (t = "/" + t), t.replace(/\/$/, "");
}
function Dr(t, e) {
  var r, n = Math.max(t.length, e.length);
  for (r = 0; r < n && t[r] === e[r]; r++)
    ;
  return {
    updated: e.slice(0, r),
    activated: e.slice(r),
    deactivated: t.slice(r)
  };
}
function Ce(t, e, r, n) {
  var i = dt(t, function(s, a, o, c) {
    var u = Wr(s, e);
    if (u)
      return Array.isArray(u) ? u.map(function(p) {
        return r(p, a, o, c);
      }) : r(u, a, o, c);
  });
  return vt(n ? i.reverse() : i);
}
function Wr(t, e) {
  return typeof t != "function" && (t = ne.extend(t)), t.options[e];
}
function Fr(t) {
  return Ce(t, "beforeRouteLeave", mt, !0);
}
function zr(t) {
  return Ce(t, "beforeRouteUpdate", mt);
}
function mt(t, e) {
  if (e)
    return function() {
      return t.apply(e, arguments);
    };
}
function Hr(t) {
  return Ce(
    t,
    "beforeRouteEnter",
    function(e, r, n, i) {
      return Gr(e, n, i);
    }
  );
}
function Gr(t, e, r) {
  return function(i, s, a) {
    return t(i, s, function(o) {
      typeof o == "function" && (e.enteredCbs[r] || (e.enteredCbs[r] = []), e.enteredCbs[r].push(o)), a(o);
    });
  };
}
var yt = /* @__PURE__ */ function(t) {
  function e(r, n) {
    t.call(this, r, n), this._startLocation = W(this.base);
  }
  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.setupListeners = function() {
    var n = this;
    if (!(this.listeners.length > 0)) {
      var i = this.router, s = i.options.scrollBehavior, a = T && s;
      a && this.listeners.push(ht());
      var o = function() {
        var c = n.current, u = W(n.base);
        n.current === I && u === n._startLocation || n.transitionTo(u, function(p) {
          a && L(i, p, c, !0);
        });
      };
      window.addEventListener("popstate", o), this.listeners.push(function() {
        window.removeEventListener("popstate", o);
      });
    }
  }, e.prototype.go = function(n) {
    window.history.go(n);
  }, e.prototype.push = function(n, i, s) {
    var a = this, o = this, c = o.current;
    this.transitionTo(n, function(u) {
      se(N(a.base + u.fullPath)), L(a.router, u, c, !1), i && i(u);
    }, s);
  }, e.prototype.replace = function(n, i, s) {
    var a = this, o = this, c = o.current;
    this.transitionTo(n, function(u) {
      ve(N(a.base + u.fullPath)), L(a.router, u, c, !1), i && i(u);
    }, s);
  }, e.prototype.ensureURL = function(n) {
    if (W(this.base) !== this.current.fullPath) {
      var i = N(this.base + this.current.fullPath);
      n ? se(i) : ve(i);
    }
  }, e.prototype.getCurrentLocation = function() {
    return W(this.base);
  }, e;
}(x);
function W(t) {
  var e = window.location.pathname, r = e.toLowerCase(), n = t.toLowerCase();
  return t && (r === n || r.indexOf(N(n + "/")) === 0) && (e = e.slice(t.length)), (e || "/") + window.location.search + window.location.hash;
}
var gt = /* @__PURE__ */ function(t) {
  function e(r, n, i) {
    t.call(this, r, n), !(i && Qr(this.base)) && ze();
  }
  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.setupListeners = function() {
    var n = this;
    if (!(this.listeners.length > 0)) {
      var i = this.router, s = i.options.scrollBehavior, a = T && s;
      a && this.listeners.push(ht());
      var o = function() {
        var u = n.current;
        ze() && n.transitionTo(X(), function(p) {
          a && L(n.router, p, u, !0), T || Y(p.fullPath);
        });
      }, c = T ? "popstate" : "hashchange";
      window.addEventListener(
        c,
        o
      ), this.listeners.push(function() {
        window.removeEventListener(c, o);
      });
    }
  }, e.prototype.push = function(n, i, s) {
    var a = this, o = this, c = o.current;
    this.transitionTo(
      n,
      function(u) {
        He(u.fullPath), L(a.router, u, c, !1), i && i(u);
      },
      s
    );
  }, e.prototype.replace = function(n, i, s) {
    var a = this, o = this, c = o.current;
    this.transitionTo(
      n,
      function(u) {
        Y(u.fullPath), L(a.router, u, c, !1), i && i(u);
      },
      s
    );
  }, e.prototype.go = function(n) {
    window.history.go(n);
  }, e.prototype.ensureURL = function(n) {
    var i = this.current.fullPath;
    X() !== i && (n ? He(i) : Y(i));
  }, e.prototype.getCurrentLocation = function() {
    return X();
  }, e;
}(x);
function Qr(t) {
  var e = W(t);
  if (!/^\/#/.test(e))
    return window.location.replace(N(t + "/#" + e)), !0;
}
function ze() {
  var t = X();
  return t.charAt(0) === "/" ? !0 : (Y("/" + t), !1);
}
function X() {
  var t = window.location.href, e = t.indexOf("#");
  return e < 0 ? "" : (t = t.slice(e + 1), t);
}
function me(t) {
  var e = window.location.href, r = e.indexOf("#"), n = r >= 0 ? e.slice(0, r) : e;
  return n + "#" + t;
}
function He(t) {
  T ? se(me(t)) : window.location.hash = t;
}
function Y(t) {
  T ? ve(me(t)) : window.location.replace(me(t));
}
var Kr = /* @__PURE__ */ function(t) {
  function e(r, n) {
    t.call(this, r, n), this.stack = [], this.index = -1;
  }
  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.push = function(n, i, s) {
    var a = this;
    this.transitionTo(
      n,
      function(o) {
        a.stack = a.stack.slice(0, a.index + 1).concat(o), a.index++, i && i(o);
      },
      s
    );
  }, e.prototype.replace = function(n, i, s) {
    var a = this;
    this.transitionTo(
      n,
      function(o) {
        a.stack = a.stack.slice(0, a.index).concat(o), i && i(o);
      },
      s
    );
  }, e.prototype.go = function(n) {
    var i = this, s = this.index + n;
    if (!(s < 0 || s >= this.stack.length)) {
      var a = this.stack[s];
      this.confirmTransition(
        a,
        function() {
          var o = i.current;
          i.index = s, i.updateRoute(a), i.router.afterHooks.forEach(function(c) {
            c && c(a, o);
          });
        },
        function(o) {
          ue(o, A.duplicated) && (i.index = s);
        }
      );
    }
  }, e.prototype.getCurrentLocation = function() {
    var n = this.stack[this.stack.length - 1];
    return n ? n.fullPath : "/";
  }, e.prototype.ensureURL = function() {
  }, e;
}(x), w = function t(e) {
  e === void 0 && (e = {}), process.env.NODE_ENV !== "production" && C(this instanceof t, "Router must be called with the new operator."), this.app = null, this.apps = [], this.options = e, this.beforeHooks = [], this.resolveHooks = [], this.afterHooks = [], this.matcher = Pr(e.routes || [], this);
  var r = e.mode || "hash";
  switch (this.fallback = r === "history" && !T && e.fallback !== !1, this.fallback && (r = "hash"), z || (r = "abstract"), this.mode = r, r) {
    case "history":
      this.history = new yt(this, e.base);
      break;
    case "hash":
      this.history = new gt(this, e.base, this.fallback);
      break;
    case "abstract":
      this.history = new Kr(this, e.base);
      break;
    default:
      process.env.NODE_ENV !== "production" && V(!1, "invalid mode: " + r);
  }
}, _t = { currentRoute: { configurable: !0 } };
w.prototype.match = function(e, r, n) {
  return this.matcher.match(e, r, n);
};
_t.currentRoute.get = function() {
  return this.history && this.history.current;
};
w.prototype.init = function(e) {
  var r = this;
  if (process.env.NODE_ENV !== "production" && V(
    ie.installed,
    "not installed. Make sure to call `Vue.use(VueRouter)` before creating root instance."
  ), this.apps.push(e), e.$once("hook:destroyed", function() {
    var a = r.apps.indexOf(e);
    a > -1 && r.apps.splice(a, 1), r.app === e && (r.app = r.apps[0] || null), r.app || r.history.teardown();
  }), !this.app) {
    this.app = e;
    var n = this.history;
    if (n instanceof yt || n instanceof gt) {
      var i = function(a) {
        var o = n.current, c = r.options.scrollBehavior, u = T && c;
        u && "fullPath" in a && L(r, a, o, !1);
      }, s = function(a) {
        n.setupListeners(), i(a);
      };
      n.transitionTo(
        n.getCurrentLocation(),
        s,
        s
      );
    }
    n.listen(function(a) {
      r.apps.forEach(function(o) {
        o._route = a;
      });
    });
  }
};
w.prototype.beforeEach = function(e) {
  return Ee(this.beforeHooks, e);
};
w.prototype.beforeResolve = function(e) {
  return Ee(this.resolveHooks, e);
};
w.prototype.afterEach = function(e) {
  return Ee(this.afterHooks, e);
};
w.prototype.onReady = function(e, r) {
  this.history.onReady(e, r);
};
w.prototype.onError = function(e) {
  this.history.onError(e);
};
w.prototype.push = function(e, r, n) {
  var i = this;
  if (!r && !n && typeof Promise < "u")
    return new Promise(function(s, a) {
      i.history.push(e, s, a);
    });
  this.history.push(e, r, n);
};
w.prototype.replace = function(e, r, n) {
  var i = this;
  if (!r && !n && typeof Promise < "u")
    return new Promise(function(s, a) {
      i.history.replace(e, s, a);
    });
  this.history.replace(e, r, n);
};
w.prototype.go = function(e) {
  this.history.go(e);
};
w.prototype.back = function() {
  this.go(-1);
};
w.prototype.forward = function() {
  this.go(1);
};
w.prototype.getMatchedComponents = function(e) {
  var r = e ? e.matched ? e : this.resolve(e).route : this.currentRoute;
  return r ? [].concat.apply(
    [],
    r.matched.map(function(n) {
      return Object.keys(n.components).map(function(i) {
        return n.components[i];
      });
    })
  ) : [];
};
w.prototype.resolve = function(e, r, n) {
  r = r || this.history.current;
  var i = Re(e, r, n, this), s = this.match(i, r), a = s.redirectedFrom || s.fullPath, o = this.history.base, c = Jr(o, a, this.mode);
  return {
    location: i,
    route: s,
    href: c,
    // for backwards compat
    normalizedTo: i,
    resolved: s
  };
};
w.prototype.getRoutes = function() {
  return this.matcher.getRoutes();
};
w.prototype.addRoute = function(e, r) {
  this.matcher.addRoute(e, r), this.history.current !== I && this.history.transitionTo(this.history.getCurrentLocation());
};
w.prototype.addRoutes = function(e) {
  process.env.NODE_ENV !== "production" && C(!1, "router.addRoutes() is deprecated and has been removed in Vue Router 4. Use router.addRoute() instead."), this.matcher.addRoutes(e), this.history.current !== I && this.history.transitionTo(this.history.getCurrentLocation());
};
Object.defineProperties(w.prototype, _t);
function Ee(t, e) {
  return t.push(e), function() {
    var r = t.indexOf(e);
    r > -1 && t.splice(r, 1);
  };
}
function Jr(t, e, r) {
  var n = r === "hash" ? "#" + e : e;
  return t ? N(t + "/" + n) : n;
}
w.install = ie;
w.version = "3.6.5";
w.isNavigationFailure = ue;
w.NavigationFailureType = A;
w.START_LOCATION = I;
z && window.Vue && window.Vue.use(w);
q(Nt);
const Xr = 3 * 60 * 1e3, Yr = {
  name: "NcReferenceWidget",
  components: {
    NcButton: Ze
  },
  props: {
    reference: {
      type: Object,
      required: !0
    },
    interactive: {
      type: Boolean,
      default: !0
    },
    interactiveOptIn: {
      type: Boolean,
      default: !1
    }
  },
  setup() {
    const t = fe(3), e = fe(!1), r = fe();
    return Mt(r, (n) => {
      var i, s;
      e.value = (s = (i = n[0]) == null ? void 0 : i.isIntersecting) != null ? s : !1;
    }), Ut(r, (n) => {
      n[0].contentRect.width < 450 ? t.value = 0 : n[0].contentRect.width < 550 ? t.value = 1 : n[0].contentRect.width < 650 ? t.value = 2 : t.value = 3;
    }), {
      compact: t,
      isVisible: e,
      widgetRoot: r
    };
  },
  data() {
    return {
      showInteractive: !1,
      rendered: !1,
      idleTimeout: null
    };
  },
  computed: {
    isInteractive() {
      return !this.interactiveOptIn && this.interactive || this.showInteractive;
    },
    hasFullWidth() {
      return Et(this.reference.richObjectType);
    },
    hasCustomWidget() {
      return xe(this.reference.richObjectType);
    },
    hasInteractiveView() {
      return xe(this.reference.richObjectType) && Pt(this.reference.richObjectType);
    },
    noAccess() {
      return this.reference && !this.reference.accessible;
    },
    descriptionStyle() {
      if (this.compact === 0)
        return {
          display: "none"
        };
      const t = this.compact < 4 ? this.compact : 3;
      return {
        lineClamp: t,
        webkitLineClamp: t
      };
    },
    compactLink() {
      const t = this.reference.openGraphObject.link;
      return t ? t.startsWith("https://") ? t.substring(8) : t.startsWith("http://") ? t.substring(7) : t : "";
    },
    route() {
      return Wt(this.$router, this.reference.openGraphObject.link);
    },
    referenceWidgetLinkComponent() {
      return this.route ? at : "a";
    },
    referenceWidgetLinkProps() {
      return this.route ? { to: this.route } : { href: this.reference.openGraphObject.link, target: "_blank" };
    }
  },
  watch: {
    isVisible: {
      handler(t) {
        if (!t) {
          this.idleTimeout = setTimeout(() => {
            this.isVisible || this.destroyWidget();
          }, Xr);
          return;
        }
        this.idleTimeout && (clearTimeout(this.idleTimeout), this.idleTimeout = null), this.rendered || this.renderWidget();
      },
      immediate: !0
    }
  },
  beforeDestroy() {
    this.destroyWidget();
  },
  methods: {
    t: S,
    enableInteractive() {
      this.showInteractive = !0, this.renderWidget();
    },
    renderWidget() {
      var e;
      if (this.$refs.customWidget && (this.$refs.customWidget.innerHTML = ""), ((e = this == null ? void 0 : this.reference) == null ? void 0 : e.richObjectType) === "open-graph")
        return;
      const t = document.createElement("div");
      this.$refs.customWidget.appendChild(t), this.$nextTick(() => {
        St(t, {
          ...this.reference,
          interactive: this.isInteractive
        }), this.rendered = !0;
      });
    },
    destroyWidget() {
      this.rendered && (kt(this.reference.richObjectType, this.$el), this.rendered = !1);
    }
  }
};
var Zr = function() {
  var e = this, r = e._self._c;
  return r("div", { ref: "widgetRoot", class: { "toggle-interactive": e.hasInteractiveView && !e.isInteractive } }, [e.reference && e.hasCustomWidget ? r("div", { ref: "customWidget", staticClass: "widget-custom", class: { "full-width": e.hasFullWidth } }) : !e.noAccess && e.reference && e.reference.openGraphObject && !e.hasCustomWidget ? r(e.referenceWidgetLinkComponent, e._b({ tag: "component", staticClass: "widget-default", attrs: { rel: "noopener noreferrer" } }, "component", e.referenceWidgetLinkProps, !1), [e.reference.openGraphObject.thumb ? r("img", { staticClass: "widget-default--image", attrs: { src: e.reference.openGraphObject.thumb } }) : e._e(), r("div", { staticClass: "widget-default--details" }, [r("p", { staticClass: "widget-default--name" }, [e._v(" " + e._s(e.reference.openGraphObject.name) + " ")]), r("p", { staticClass: "widget-default--description", style: e.descriptionStyle }, [e._v(" " + e._s(e.reference.openGraphObject.description) + " ")]), r("p", { staticClass: "widget-default--link" }, [e._v(" " + e._s(e.compactLink) + " ")])])]) : e._e(), e.interactiveOptIn && e.hasInteractiveView && !e.isInteractive ? r("NcButton", { staticClass: "toggle-interactive--button", on: { click: e.enableInteractive } }, [e._v(" " + e._s(e.t("Enable interactive view")) + " ")]) : e._e()], 1);
}, en = [], tn = /* @__PURE__ */ O(
  Yr,
  Zr,
  en,
  !1,
  null,
  "08d7279d",
  null,
  null
);
const rn = tn.exports, nn = {
  name: "NcCustomPickerElement",
  props: {
    /**
     * The reference provider
     */
    provider: {
      type: Object,
      required: !0
    }
  },
  emits: [
    "cancel",
    "submit"
  ],
  data() {
    return {
      isRegistered: F(this.provider.id),
      renderResult: null
    };
  },
  mounted() {
    this.isRegistered && this.renderElement();
  },
  beforeDestroy() {
    this.isRegistered && xt(this.provider.id, this.$el, this.renderResult);
  },
  methods: {
    renderElement() {
      this.$refs.domElement && (this.$refs.domElement.innerHTML = "");
      const t = $t(this.$refs.domElement, { providerId: this.provider.id, accessible: !1 });
      Promise.resolve(t).then((e) => {
        var r, n;
        this.renderResult = e, (r = this.renderResult.object) != null && r._isVue && ((n = this.renderResult.object) != null && n.$on) && (this.renderResult.object.$on("submit", this.onSubmit), this.renderResult.object.$on("cancel", this.onCancel)), this.renderResult.element.addEventListener("submit", (i) => {
          this.onSubmit(i.detail);
        }), this.renderResult.element.addEventListener("cancel", this.onCancel);
      });
    },
    onSubmit(t) {
      this.$emit("submit", t);
    },
    onCancel() {
      this.$emit("cancel");
    }
  }
};
var sn = function() {
  var e = this, r = e._self._c;
  return r("div", { ref: "domElement" });
}, an = [], on = /* @__PURE__ */ O(
  nn,
  sn,
  an,
  !1,
  null,
  "25f1cef8",
  null,
  null
);
const cn = on.exports;
q(Lt);
const wt = "any-link", bt = {
  id: wt,
  title: S("Any link"),
  icon_url: qt("core", "filetypes/link.svg")
};
window._vue_richtext_reference_providers || (window._vue_richtext_reference_providers = Je("core", "reference-provider-list", []));
window._vue_richtext_reference_provider_timestamps || (window._vue_richtext_reference_provider_timestamps = Je("core", "reference-provider-timestamps", {}));
function un(t) {
  return t === wt ? bt : Rt().find((e) => e.id === t);
}
function Rt() {
  return window._vue_richtext_reference_providers.filter((t) => {
    const e = !!t.search_providers_ids && t.search_providers_ids.length > 0 || F(t.id);
    return e || console.debug("[smart picker]", t.id, "reference provider is discoverable but does not have any related search provider or custom picker component registered"), e;
  });
}
function ln(t) {
  const e = window._vue_richtext_reference_provider_timestamps;
  return t.sort((r, n) => r.order === n.order ? 0 : r.order > n.order ? 1 : -1).sort((r, n) => {
    const i = e[r.id], s = e[n.id];
    return i === s ? 0 : s === void 0 ? -1 : i === void 0 ? 1 : i > s ? -1 : 1;
  });
}
function fn(t, e = null) {
  const r = Rt(), n = t.replace(/[/\-\\^$*+?.()|[\]{}]/g, "\\$&"), i = new RegExp(n, "i"), a = ln(r).filter((c) => c.title.match(i)), o = e ? a.slice(0, e) : a;
  return (t === "" || o.length === 0) && o.push(bt), o;
}
function hn(t) {
  const e = Math.floor(Date.now() / 1e3), r = {
    timestamp: e
  }, n = Z("references/provider/{providerId}", { providerId: t });
  ye.put(n, r).then((i) => {
    window._vue_richtext_reference_provider_timestamps[t] = e;
  });
}
let Ge = 0;
function Ct(t, e) {
  return function() {
    const r = this, n = arguments;
    clearTimeout(Ge), Ge = setTimeout(function() {
      t.apply(r, n);
    }, e || 0);
  };
}
function Pe(t) {
  try {
    return !!new URL(t);
  } catch {
    return !1;
  }
}
q(Ke, Tt);
const pn = {
  name: "LinkVariantIcon",
  emits: ["click"],
  props: {
    title: {
      type: String
    },
    fillColor: {
      type: String,
      default: "currentColor"
    },
    size: {
      type: Number,
      default: 24
    }
  }
};
var dn = function() {
  var e = this, r = e._self._c;
  return r("span", e._b({ staticClass: "material-design-icon link-variant-icon", attrs: { "aria-hidden": e.title ? null : !0, "aria-label": e.title, role: "img" }, on: { click: function(n) {
    return e.$emit("click", n);
  } } }, "span", e.$attrs, !1), [r("svg", { staticClass: "material-design-icon__svg", attrs: { fill: e.fillColor, width: e.size, height: e.size, viewBox: "0 0 24 24" } }, [r("path", { attrs: { d: "M10.59,13.41C11,13.8 11,14.44 10.59,14.83C10.2,15.22 9.56,15.22 9.17,14.83C7.22,12.88 7.22,9.71 9.17,7.76V7.76L12.71,4.22C14.66,2.27 17.83,2.27 19.78,4.22C21.73,6.17 21.73,9.34 19.78,11.29L18.29,12.78C18.3,11.96 18.17,11.14 17.89,10.36L18.36,9.88C19.54,8.71 19.54,6.81 18.36,5.64C17.19,4.46 15.29,4.46 14.12,5.64L10.59,9.17C9.41,10.34 9.41,12.24 10.59,13.41M13.41,9.17C13.8,8.78 14.44,8.78 14.83,9.17C16.78,11.12 16.78,14.29 14.83,16.24V16.24L11.29,19.78C9.34,21.73 6.17,21.73 4.22,19.78C2.27,17.83 2.27,14.66 4.22,12.71L5.71,11.22C5.7,12.04 5.83,12.86 6.11,13.65L5.64,14.12C4.46,15.29 4.46,17.19 5.64,18.36C6.81,19.54 8.71,19.54 9.88,18.36L13.41,14.83C14.59,13.66 14.59,11.76 13.41,10.59C13,10.2 13,9.56 13.41,9.17Z" } }, [e.title ? r("title", [e._v(e._s(e.title))]) : e._e()])])]);
}, vn = [], mn = /* @__PURE__ */ O(
  pn,
  dn,
  vn,
  !1,
  null,
  null,
  null,
  null
);
const Se = mn.exports, yn = {
  name: "NcProviderList",
  components: {
    NcSelect: Ye,
    NcHighlight: Xe,
    NcEmptyContent: ge,
    LinkVariantIcon: Se
  },
  emits: [
    "select-provider",
    "submit"
  ],
  data() {
    return {
      selectedProvider: null,
      query: "",
      multiselectPlaceholder: S("Select provider"),
      providerIconAlt: S("Provider icon")
    };
  },
  computed: {
    options() {
      const t = [];
      return this.query !== "" && Pe(this.query) && t.push({
        id: this.query,
        title: this.query,
        isLink: !0
      }), t.push(...fn(this.query)), t;
    }
  },
  methods: {
    focus() {
      setTimeout(() => {
        var t, e, r;
        (r = (e = (t = this.$refs["provider-select"]) == null ? void 0 : t.$el) == null ? void 0 : e.querySelector("#provider-select-input")) == null || r.focus();
      }, 300);
    },
    onProviderSelected(t) {
      t !== null && (t.isLink ? this.$emit("submit", t.title) : this.$emit("select-provider", t), this.selectedProvider = null);
    },
    onSearch(t, e) {
      this.query = t;
    }
  }
};
var gn = function() {
  var e = this, r = e._self._c;
  return r("div", { staticClass: "provider-list" }, [r("NcSelect", { ref: "provider-select", staticClass: "provider-list--select", attrs: { "input-id": "provider-select-input", label: "title", placeholder: e.multiselectPlaceholder, options: e.options, "append-to-body": !1, "clear-search-on-select": !0, "clear-search-on-blur": () => !1, filterable: !1 }, on: { search: e.onSearch, input: e.onProviderSelected }, scopedSlots: e._u([{ key: "option", fn: function(n) {
    return [n.isLink ? r("div", { staticClass: "provider" }, [r("LinkVariantIcon", { staticClass: "link-icon", attrs: { size: 20 } }), r("span", [e._v(e._s(n.title))])], 1) : r("div", { staticClass: "provider" }, [r("img", { staticClass: "provider-icon", attrs: { src: n.icon_url, alt: e.providerIconAlt } }), r("NcHighlight", { staticClass: "option-text", attrs: { search: e.query, text: n.title } })], 1)];
  } }]), model: { value: e.selectedProvider, callback: function(n) {
    e.selectedProvider = n;
  }, expression: "selectedProvider" } }), r("NcEmptyContent", { staticClass: "provider-list--empty-content", scopedSlots: e._u([{ key: "icon", fn: function() {
    return [r("LinkVariantIcon")];
  }, proxy: !0 }]) })], 1);
}, _n = [], wn = /* @__PURE__ */ O(
  yn,
  gn,
  _n,
  !1,
  null,
  "e880790e",
  null,
  null
);
const bn = wn.exports;
q(It);
const Rn = {
  name: "NcRawLinkInput",
  components: {
    LinkVariantIcon: Se,
    NcEmptyContent: ge,
    NcLoadingIcon: Ft,
    NcReferenceWidget: rn,
    NcTextField: zt
  },
  props: {
    /**
     * The reference provider
     */
    provider: {
      type: Object,
      required: !0
    }
  },
  emits: [
    "submit"
  ],
  data() {
    return {
      inputValue: "",
      loading: !1,
      reference: null,
      abortController: null,
      inputPlaceholder: S("Enter link")
    };
  },
  computed: {
    isLinkValid() {
      return Pe(this.inputValue);
    }
  },
  methods: {
    focus() {
      var t;
      (t = this.$refs["url-input"].$el.getElementsByTagName("input")[0]) == null || t.focus();
    },
    onSubmit(t) {
      const e = t.target.value;
      this.isLinkValid && this.$emit("submit", e);
    },
    onClear() {
      this.inputValue = "", this.reference = null;
    },
    onInput() {
      this.reference = null, this.abortController && this.abortController.abort(), this.isLinkValid && Ct(() => {
        this.updateReference();
      }, 500)();
    },
    updateReference() {
      this.loading = !0, this.abortController = new AbortController(), ye.get(Z("references/resolve", 2) + "?reference=" + encodeURIComponent(this.inputValue), {
        signal: this.abortController.signal
      }).then((t) => {
        this.reference = t.data.ocs.data.references[this.inputValue];
      }).catch((t) => {
        console.error(t);
      }).then(() => {
        this.loading = !1;
      });
    }
  }
};
var Cn = function() {
  var e = this, r = e._self._c;
  return r("div", { staticClass: "raw-link" }, [r("div", { staticClass: "input-wrapper" }, [r("NcTextField", { ref: "url-input", attrs: { value: e.inputValue, "show-trailing-button": e.inputValue !== "", label: e.inputPlaceholder }, on: { "update:value": [function(n) {
    e.inputValue = n;
  }, e.onInput], "trailing-button-click": e.onClear }, nativeOn: { keyup: function(n) {
    return !n.type.indexOf("key") && e._k(n.keyCode, "enter", 13, n.key, "Enter") ? null : e.onSubmit.apply(null, arguments);
  } } }, [e.loading ? r("NcLoadingIcon", { attrs: { size: 16 } }) : r("LinkVariantIcon", { attrs: { size: 16 } })], 1)], 1), e.reference !== null ? r("NcReferenceWidget", { staticClass: "reference-widget", attrs: { reference: e.reference } }) : r("NcEmptyContent", { staticClass: "raw-link--empty-content", scopedSlots: e._u([{ key: "icon", fn: function() {
    return [e.provider.icon_url ? r("img", { staticClass: "provider-icon", attrs: { src: e.provider.icon_url } }) : r("LinkVariantIcon")];
  }, proxy: !0 }]) })], 1);
}, En = [], Pn = /* @__PURE__ */ O(
  Rn,
  Cn,
  En,
  !1,
  null,
  "d0ba247a",
  null,
  null
);
const Sn = Pn.exports, kn = {
  name: "NcSearchResult",
  components: {
    NcHighlight: Xe
  },
  props: {
    /**
     * Unified search result entry
     */
    entry: {
      type: Object,
      required: !0
    },
    /**
     * The query that led to getting this result
     * Used to highlight the entry text
     */
    query: {
      type: String,
      required: !0
    }
  }
};
var xn = function() {
  var e = this, r = e._self._c;
  return r("div", { staticClass: "result" }, [e.entry.icon ? r("div", { staticClass: "result--icon-class", class: { [e.entry.icon]: !0, rounded: e.entry.rounded } }) : r("img", { staticClass: "result--image", class: { rounded: e.entry.rounded }, attrs: { src: e.entry.thumbnailUrl } }), r("div", { staticClass: "result--content" }, [r("span", { staticClass: "result--content--name" }, [r("NcHighlight", { attrs: { search: e.query, text: e.entry.title } })], 1), r("span", { staticClass: "result--content--subline" }, [r("NcHighlight", { attrs: { search: e.query, text: e.entry.subline } })], 1)])]);
}, $n = [], On = /* @__PURE__ */ O(
  kn,
  xn,
  $n,
  !1,
  null,
  "7a394a58",
  null,
  null
);
const Nn = On.exports;
q(At, Ke, Vt);
const Qe = 5, Ln = {
  name: "NcSearch",
  components: {
    LinkVariantIcon: Se,
    DotsHorizontalIcon: Ht,
    NcEmptyContent: ge,
    NcSelect: Ye,
    NcSearchResult: Nn
  },
  props: {
    /**
     * The selected reference provider
     */
    provider: {
      type: Object,
      required: !0
    },
    showEmptyContent: {
      type: Boolean,
      default: !0
    },
    searchPlaceholder: {
      type: String,
      default: null
    }
  },
  emits: [
    "submit"
  ],
  data() {
    return {
      searchQuery: "",
      selectedResult: null,
      resultsBySearchProvider: {},
      searching: !1,
      searchingMoreOf: null,
      abortController: null,
      noOptionsText: S("Start typing to search"),
      providerIconAlt: S("Provider icon")
    };
  },
  computed: {
    mySearchPlaceholder() {
      return this.searchPlaceholder || S("Search");
    },
    searchProviderIds() {
      return this.provider.search_providers_ids;
    },
    options() {
      if (this.searchQuery === "")
        return [];
      const t = [];
      return Pe(this.searchQuery) && t.push(this.rawLinkEntry), t.push(...this.formattedSearchResults), t;
    },
    rawLinkEntry() {
      return {
        id: "rawLinkEntry",
        resourceUrl: this.searchQuery,
        isRawLink: !0
      };
    },
    formattedSearchResults() {
      const t = [];
      return this.searchProviderIds.forEach((e) => {
        if (this.resultsBySearchProvider[e].entries.length > 0) {
          (this.searchProviderIds.length > 1 || this.resultsBySearchProvider[e].entries.length > 1) && t.push({
            id: "groupTitle-" + e,
            name: this.resultsBySearchProvider[e].name,
            isCustomGroupTitle: !0,
            providerId: e
          });
          const r = this.resultsBySearchProvider[e].entries.map((n, i) => ({
            id: "provider-" + e + "-entry-" + i,
            ...n
          }));
          t.push(...r), this.resultsBySearchProvider[e].isPaginated && t.push({
            id: "moreOf-" + e,
            name: this.resultsBySearchProvider[e].name,
            isMore: !0,
            providerId: e,
            isLoading: this.searchingMoreOf === e
          });
        }
      }), t;
    }
  },
  mounted() {
    this.resetResults();
  },
  beforeDestroy() {
    this.cancelSearchRequests();
  },
  methods: {
    t: S,
    resetResults() {
      const t = {};
      this.searchProviderIds.forEach((e) => {
        t[e] = {
          entries: []
        };
      }), this.resultsBySearchProvider = t;
    },
    focus() {
      setTimeout(() => {
        var t, e, r;
        (r = (e = (t = this.$refs["search-select"]) == null ? void 0 : t.$el) == null ? void 0 : e.querySelector("#search-select-input")) == null || r.focus();
      }, 300);
    },
    cancelSearchRequests() {
      this.abortController && this.abortController.abort();
    },
    onSearchInput(t, e) {
      this.searchQuery = t, Ct(() => {
        this.updateSearch();
      }, 500)();
    },
    onSelectResultSelected(t) {
      t !== null && (t.resourceUrl ? (this.cancelSearchRequests(), this.$emit("submit", t.resourceUrl)) : t.isMore && this.searchMoreOf(t.providerId).then(() => {
        this.selectedResult = null;
      }));
    },
    searchMoreOf(t) {
      return this.searchingMoreOf = t, this.cancelSearchRequests(), this.searchProviders(t);
    },
    updateSearch() {
      if (this.cancelSearchRequests(), this.resetResults(), this.searchQuery === "") {
        this.searching = !1;
        return;
      }
      return this.searchProviders();
    },
    searchProviders(t = null) {
      var r, n;
      this.abortController = new AbortController(), this.searching = !0;
      const e = t === null ? [...this.searchProviderIds].map((i) => this.searchOneProvider(i)) : [this.searchOneProvider(t, (n = (r = this.resultsBySearchProvider[t]) == null ? void 0 : r.cursor) != null ? n : null)];
      return Promise.allSettled(e).then((i) => {
        !!i.find((a) => a.status === "rejected" && (a.reason.name === "CanceledError" || a.reason.code === "ERR_CANCELED")) || (this.searching = !1, this.searchingMoreOf = null);
      });
    },
    searchOneProvider(t, e = null) {
      const r = e === null ? Z("search/providers/{providerId}/search?term={term}&limit={limit}", { providerId: t, term: this.searchQuery, limit: Qe }) : Z("search/providers/{providerId}/search?term={term}&limit={limit}&cursor={cursor}", { providerId: t, term: this.searchQuery, limit: Qe, cursor: e });
      return ye.get(r, {
        signal: this.abortController.signal
      }).then((n) => {
        const i = n.data.ocs.data;
        this.resultsBySearchProvider[t].name = i.name, this.resultsBySearchProvider[t].cursor = i.cursor, this.resultsBySearchProvider[t].isPaginated = i.isPaginated, this.resultsBySearchProvider[t].entries.push(...i.entries);
      });
    }
  }
};
var Tn = function() {
  var e = this, r = e._self._c;
  return r("div", { staticClass: "smart-picker-search", class: { "with-empty-content": e.showEmptyContent } }, [r("NcSelect", { ref: "search-select", staticClass: "smart-picker-search--select", attrs: { "input-id": "search-select-input", label: "name", placeholder: e.mySearchPlaceholder, options: e.options, "append-to-body": !1, "close-on-select": !1, "clear-search-on-select": !1, "clear-search-on-blur": () => !1, "reset-focus-on-options-change": !1, filterable: !1, autoscroll: !0, "reset-on-options-change": !1, loading: e.searching }, on: { search: e.onSearchInput, input: e.onSelectResultSelected }, scopedSlots: e._u([{ key: "option", fn: function(n) {
    return [n.isRawLink ? r("div", { staticClass: "custom-option" }, [r("LinkVariantIcon", { staticClass: "option-simple-icon", attrs: { size: 20 } }), r("span", { staticClass: "option-text" }, [e._v(" " + e._s(e.t("Raw link {options}", { options: n.resourceUrl })) + " ")])], 1) : n.resourceUrl ? r("NcSearchResult", { staticClass: "search-result", attrs: { entry: n, query: e.searchQuery } }) : n.isCustomGroupTitle ? r("span", { staticClass: "custom-option group-name" }, [e.provider.icon_url ? r("img", { staticClass: "provider-icon group-name-icon", attrs: { src: e.provider.icon_url } }) : e._e(), r("span", { staticClass: "option-text" }, [r("strong", [e._v(e._s(n.name))])])]) : n.isMore ? r("span", { class: { "custom-option": !0 } }, [n.isLoading ? r("span", { staticClass: "option-simple-icon icon-loading-small" }) : r("DotsHorizontalIcon", { staticClass: "option-simple-icon", attrs: { size: 20 } }), r("span", { staticClass: "option-text" }, [e._v(" " + e._s(e.t('Load more "{options}"', { options: n.name })) + " ")])], 1) : e._e()];
  } }, { key: "no-options", fn: function() {
    return [e._v(" " + e._s(e.noOptionsText) + " ")];
  }, proxy: !0 }]), model: { value: e.selectedResult, callback: function(n) {
    e.selectedResult = n;
  }, expression: "selectedResult" } }), e.showEmptyContent ? r("NcEmptyContent", { staticClass: "smart-picker-search--empty-content", scopedSlots: e._u([{ key: "icon", fn: function() {
    return [e.provider.icon_url ? r("img", { staticClass: "provider-icon", attrs: { alt: e.providerIconAlt, src: e.provider.icon_url } }) : r("LinkVariantIcon")];
  }, proxy: !0 }], null, !1, 2922132592) }) : e._e()], 1);
}, In = [], Vn = /* @__PURE__ */ O(
  Ln,
  Tn,
  In,
  !1,
  null,
  "97d196f0",
  null,
  null
);
const An = Vn.exports, D = {
  providerList: 1,
  standardLinkInput: 2,
  searchInput: 3,
  customElement: 4
}, jn = {
  name: "NcReferencePicker",
  components: {
    NcCustomPickerElement: cn,
    NcProviderList: bn,
    NcRawLinkInput: Sn,
    NcSearch: An
  },
  props: {
    /**
     * Provider to select on creation
     * Default: null. Show the provider list
     */
    initialProvider: {
      type: Object,
      default: () => null
    },
    /**
     * Optional width in pixels
     * Default: 100%
     */
    width: {
      type: Number,
      default: null
    },
    /**
     * Focus on the provider list select input on creation
     * Default: true
     */
    focusOnCreate: {
      type: Boolean,
      default: !0
    }
  },
  emits: [
    "cancel",
    "cancel-raw-link",
    "cancel-search",
    "provider-selected",
    "submit"
  ],
  data() {
    return {
      MODES: D,
      selectedProvider: this.initialProvider
    };
  },
  computed: {
    mode() {
      return this.selectedProvider === null ? D.providerList : F(this.selectedProvider.id) ? D.customElement : this.selectedProvider.search_providers_ids ? D.searchInput : D.standardLinkInput;
    },
    pickerWrapperStyle() {
      return {
        width: this.width ? this.width + "px" : void 0
      };
    }
  },
  mounted() {
    this.focusOnCreate && (this.initialProvider ? setTimeout(() => {
      var t;
      (t = this.$refs["url-input"]) == null || t.focus();
    }, 300) : this.$nextTick(() => {
      var t;
      (t = this.$refs["provider-list"]) == null || t.focus();
    }));
  },
  methods: {
    onEscapePressed() {
      this.selectedProvider !== null ? this.deselectProvider() : this.cancelProviderSelection();
    },
    onProviderSelected(t) {
      this.selectedProvider = t, this.$emit("provider-selected", t), this.$nextTick(() => {
        var e;
        (e = this.$refs["url-input"]) == null || e.focus();
      });
    },
    cancelCustomElement() {
      this.deselectProvider();
    },
    cancelSearch() {
      var t;
      this.$emit("cancel-search", (t = this.selectedProvider) == null ? void 0 : t.title), this.deselectProvider();
    },
    cancelRawLinkInput() {
      var t;
      this.$emit("cancel-raw-link", (t = this.selectedProvider) == null ? void 0 : t.title), this.deselectProvider();
    },
    cancelProviderSelection() {
      this.$emit("cancel");
    },
    submitLink(t) {
      this.selectedProvider !== null && hn(this.selectedProvider.id), this.$emit("submit", t), this.deselectProvider();
    },
    deselectProvider() {
      this.selectedProvider = null, this.$emit("provider-selected", null), setTimeout(() => {
        var t;
        (t = this.$refs["provider-list"]) == null || t.focus();
      }, 300);
    }
  }
};
var Bn = function() {
  var e = this, r = e._self._c;
  return r("div", { staticClass: "reference-picker", style: e.pickerWrapperStyle, attrs: { tabindex: "-1" }, on: { keydown: function(n) {
    return !n.type.indexOf("key") && e._k(n.keyCode, "esc", 27, n.key, ["Esc", "Escape"]) ? null : (n.stopPropagation(), n.preventDefault(), e.onEscapePressed.apply(null, arguments));
  } } }, [e.mode === e.MODES.providerList ? r("NcProviderList", { ref: "provider-list", on: { "select-provider": e.onProviderSelected, submit: e.submitLink, cancel: e.cancelProviderSelection } }) : e.mode === e.MODES.standardLinkInput ? r("NcRawLinkInput", { ref: "url-input", attrs: { provider: e.selectedProvider }, on: { submit: e.submitLink, cancel: e.cancelRawLinkInput } }) : e.mode === e.MODES.searchInput ? r("NcSearch", { ref: "url-input", attrs: { provider: e.selectedProvider }, on: { cancel: e.cancelSearch, submit: e.submitLink } }) : e.mode === e.MODES.customElement ? r("div", { staticClass: "custom-element-wrapper" }, [r("NcCustomPickerElement", { attrs: { provider: e.selectedProvider }, on: { submit: e.submitLink, cancel: e.cancelCustomElement } })], 1) : e._e()], 1);
}, qn = [], Mn = /* @__PURE__ */ O(
  jn,
  Bn,
  qn,
  !1,
  null,
  "12c38c93",
  null,
  null
);
const Un = Mn.exports;
q(Bt, jt);
const Dn = {
  name: "NcReferencePickerModal",
  components: {
    NcReferencePicker: Un,
    NcModal: Gt,
    NcButton: Ze,
    ArrowLeftIcon: Kt,
    CloseIcon: Jt
  },
  props: {
    /**
     * Provider to select on creation
     * Show the provider list if no initial one is provided
     */
    initialProvider: {
      type: Object,
      default: () => null
    },
    /**
     * Focus on the input item on create
     */
    focusOnCreate: {
      type: Boolean,
      default: !0
    },
    /**
     * If true, add the modal content to the Viewer trap elements via the event-bus
     */
    isInsideViewer: {
      type: Boolean,
      default: !1
    }
  },
  emits: [
    "cancel",
    "submit"
  ],
  data() {
    return {
      show: !0,
      selectedProvider: this.initialProvider,
      backButtonTitle: S("Back to provider selection"),
      closeButtonTitle: S("Close"),
      closeButtonLabel: S("Close Smart Picker")
    };
  },
  computed: {
    isProviderSelected() {
      return this.selectedProvider !== null;
    },
    showBackButton() {
      return this.initialProvider === null && this.isProviderSelected;
    },
    modalSize() {
      var t;
      return this.isProviderSelected && F(this.selectedProvider.id) ? (t = Ot(this.selectedProvider.id)) != null ? t : "large" : "normal";
    },
    showModalName() {
      return !this.isProviderSelected || !F(this.selectedProvider.id);
    },
    modalName() {
      return this.isProviderSelected ? this.selectedProvider.title : S("Smart Picker");
    }
  },
  mounted() {
    if (this.isInsideViewer) {
      const t = this.$refs.modal_content;
      Qt("viewer:trapElements:changed", t);
    }
  },
  methods: {
    onCancel() {
      this.show = !1, this.$emit("cancel");
    },
    onSubmit(t) {
      this.show = !1, this.$emit("submit", t);
    },
    onProviderSelect(t) {
      this.selectedProvider = t, t === null && this.initialProvider !== null && this.onCancel();
    },
    onBackClicked() {
      this.$refs.referencePicker.deselectProvider();
    }
  }
};
var Wn = function() {
  var e = this, r = e._self._c;
  return e.show ? r("NcModal", { staticClass: "reference-picker-modal", attrs: { size: e.modalSize, "can-close": !1 }, on: { close: e.onCancel } }, [r("div", { ref: "modal_content", staticClass: "reference-picker-modal--content" }, [e.showBackButton ? r("NcButton", { staticClass: "back-button", attrs: { "aria-label": e.backButtonTitle, title: e.backButtonTitle }, on: { click: e.onBackClicked }, scopedSlots: e._u([{ key: "icon", fn: function() {
    return [r("ArrowLeftIcon")];
  }, proxy: !0 }], null, !1, 3001860362) }) : e._e(), r("NcButton", { staticClass: "close-button", attrs: { "aria-label": e.closeButtonLabel, title: e.closeButtonTitle, type: "tertiary" }, on: { click: e.onCancel }, scopedSlots: e._u([{ key: "icon", fn: function() {
    return [r("CloseIcon")];
  }, proxy: !0 }], null, !1, 2491825086) }), e.showModalName ? r("h2", [e._v(" " + e._s(e.modalName) + " ")]) : e._e(), r("NcReferencePicker", { ref: "referencePicker", attrs: { "initial-provider": e.initialProvider, "focus-on-create": e.focusOnCreate }, on: { "provider-selected": e.onProviderSelect, submit: e.onSubmit, cancel: e.onCancel } })], 1)]) : e._e();
}, Fn = [], zn = /* @__PURE__ */ O(
  Dn,
  Wn,
  Fn,
  !1,
  null,
  "ab09ebaa",
  null,
  null
);
const Hn = zn.exports;
async function pi(t = null, e = void 0) {
  return await new Promise((r, n) => {
    var u;
    const i = "referencePickerModal", s = document.createElement("div");
    s.id = i, document.body.append(s);
    const a = t === null ? null : (u = un(t)) != null ? u : null, o = Dt.extend(Hn), c = new o({
      propsData: {
        initialProvider: a,
        isInsideViewer: e
      }
    }).$mount(s);
    c.$on("cancel", () => {
      c.$destroy(), n(new Error("User cancellation"));
    }), c.$on("submit", (p) => {
      c.$destroy(), r(p);
    });
  });
}
export {
  at as L,
  rn as N,
  wt as a,
  un as b,
  Rt as c,
  fn as d,
  Un as e,
  Hn as f,
  pi as g,
  An as h,
  ln as s
};
